{
  "states": {
    "loading": "Loading...",
    "unavailable": "--"
  },
  "button": {
    "defaultCity": "San Francisco"
  },
  "conditions": {
    "Clear": "Clear",
    "Clouds": "Clouds",
    "Rain": "Rain",
    "Drizzle": "Drizzle",
    "Thunderstorm": "Thunderstorm",
    "Snow": "Snow",
    "Mist": "Mist",
    "Smoke": "Smoke",
    "Haze": "Haze",
    "Dust": "Dust",
    "Fog": "Fog",
    "Sand": "Sand",
    "Ash": "Ash",
    "Squall": "Squall",
    "Tornado": "Tornado"
  },
  "modal": {
    "defaultTitle": "Weather",
    "subtitle": "Current conditions",
    "showFahrenheit_aria": "Show Fahrenheit",
    "showCelsius_aria": "Show Celsius",
    "switchToCelsius_title": "Switch to °C",
    "switchToFahrenheit_title": "Switch to °F",
    "feelsLike": "Feels like {{temp}}°{{unit}}",
    "humidityWind": "Humidity {{humidity}}% · Wind {{wind}}",
    "windSpeed": "{{speed}} mph",
    "hourlyNow": "Now",
    "hourlyOffset": "{{hours}}h",
    "hourlyStrip_aria": "Hourly temperature",
    "hourlyLocked": "Hourly forecast is a Pro feature.",
    "statsLocked": "Weather details are a Pro feature.",
    "stats": {
      "sunrise": "Sunrise",
      "sunset": "Sunset",
      "feels": "Feels",
      "humidity": "Humidity",
      "wind": "Wind",
      "rain": "Rain"
    },
    "rainInches": "{{value}} in",
    "forecastTitle": "5-Day Forecast",
    "forecastLoading": "Loading forecast…",
    "forecastUnavailable": "Forecast unavailable",
    "forecastLocked": "5-day forecast is a Pro feature.",
    "forecastRow_aria": "Five day forecast",
    "proHeadline": "The full forecast is part of Pro.",
    "proFeatures": "Hourly · Detailed conditions · 5-day outlook."
  }
}
